import 'core-js/es7/reflect';
import 'core-js/client/shim';
import 'zone.js/dist/zone';

// /* IE10 and IE11 requires the following for NgClass support on SVG elements */
import 'classlist.js';  // Run `npm install --save classlist.js`.